import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App'
import head from 'components/head/head.vue'
import home from 'components/home/home.vue'
import footer from 'components/footer/footer.vue'
import fashion from 'components/fashion/fashion.vue'
import walkin from 'components/walkin/walkin.vue'
import vip from 'components/vip/vip.vue'
import stores from 'components/stores/stores.vue'
import slide from 'components/slide/slide.vue'
import micro from 'components/micro/micro.vue'
import crossover from 'components/crossover/crossover.vue'
import broadcast from 'components/broadcast/broadcast.vue'
import introduction from 'components/introduction/introduction.vue'
import contactus from 'components/contactus/contactus.vue'
import brandmark from 'components/brandmark/brandmark.vue'
import space from 'components/space/space.vue'
import gc_boadcast from 'components/gc_boadcast/gc_boadcast.vue'
import n_select from 'components/n_select/n_select.vue'
import maps from 'components/maps/maps.vue'

Vue.use(VueRouter);


var bpp = Vue.extend(App);

var router = new VueRouter({
  mode: "history",
});
router.map({
  '/':{
    component:home
  },
  'head':{
    component:head
  },
  'home':{
    component:home
  },
  'footer':{
    component:footer
  },
  'fashion':{
    component:fashion
  },
  'walkin':{
    component:walkin
  },
  'vip':{
    component:vip
  },
  'stores':{
    component:stores
  },
  'slide/:id':{
    name:'slide',
    component:slide
  },
  'micro':{
    component:micro
  },
  'crossover':{
    component:crossover
  },
  'broadcast':{
    component:broadcast
  },
  'introduction':{
    component:introduction
  },
  'contactus':{
    component:contactus
  },
  'brandmark':{
    component:brandmark
  },
  'space':{
    component:space
  },
  'gc_boadcast':{
    component:gc_boadcast
  },
  'n_select/:name':{
    name:'n_select',
    component:n_select
  },
  'maps/:name':{
    name:'maps',
    component:maps
  },

})

router.start(bpp,'#app');
// router.go('/home');




// WEBPACK FOOTER //
// ./src/main.js